import React, { useState } from 'react'
import { PrimaryButton } from 'components/Shared/PrimaryButton'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ContainedButton } from 'components/Shared/ContainedButton'
import styles from './OrderForwardingSummary.module.css'

const LANGUAGES = ['EN', 'DE', 'PL']

export const OrderForwardingSummarySettingsDialog = ({ open, onClose }) => {
  const { t } = useTranslation()
  const [language, setLanguage] = useState(LANGUAGES[2])

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value)
  }

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={() => onClose(null)}
    >
      <DialogTitle>{t(
        'order.details.orderForwardingSummaryPdf.settingsDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormControl>
            <FormLabel>{t(
              'order.details.orderForwardingSummaryPdf.settingsDialog.languageSelect')}</FormLabel>
            <RadioGroup
              row
              name="order-forwarding-summary-language"
              value={language}
              onChange={handleLanguageChange}
            >
              {LANGUAGES.map(lang => (
                <FormControlLabel key={lang} value={lang}
                                  control={<Radio color="primary"/>}
                                  label={lang}/>
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={() => onClose(null)}
          label={t('notifications.back')}/>
        <ContainedButton
          onClick={() => onClose({ language })}
          label={t(
            'order.details.orderForwardingSummaryPdf.settingsDialog.confirm')}
          className={styles.confirmButton}
        />
      </DialogActions>
    </Dialog>
  )
}